import React, { useMemo } from "react";
import SidebarItem from "../SidebarItem";
import { useReportsMenuItems } from "../../../apis/reportsApi.hooks";
import { useFeatureFlag } from "../../../context/features";

export const ReportsSidebar = () => {
  const { data } = useReportsMenuItems();
  const { isFeatureEnabled } = useFeatureFlag();

  const menuItems = useMemo(() => {
    if (!data) return [];

    return data.filter(
      (item) =>
        item.fields.showOnMenu &&
        (!item.fields.featureFlag || isFeatureEnabled(item.fields.featureFlag)),
    );
  }, [data]);

  if (!data) {
    return null;
  }

  return (
    <>
      {menuItems.map((item, index) => (
        <SidebarItem
          key={index}
          name={item.fields.name || ""}
          path={`/reporting/${item.fields.slug}`}
          reactPage
        />
      ))}
    </>
  );
};
